import React from "react";
import Card from "react-bootstrap/Card";
import { ImPointRight } from "react-icons/im";

function AboutCard() {
  return (
    <Card className="quote-card-view">
      <Card.Body>
        <blockquote className="blockquote mb-0">
          <p style={{ textAlign: "justify" }}>
            Hello Everyone, I am <span className="blue">Marmik </span>
            from <span className="blue"> Himatnagar, India.</span>
            <br />I am T.Y. B.Tech. Computer Engineering student from <br />
            <a href="https://www.spu.ac.in" className="blue">SPU</a>, Visnagar.
            <br />
            <br />
            Apart from coding, some other activities that I love to do!
          </p>
          <ul>
            <li className="about-activity">
              <ImPointRight /> Watching tech course from Udemy, Coursera, Skillshare...
            </li>
            <li className="about-activity">
              <ImPointRight /> Playing Chess
            </li>
            <li className="about-activity">
              <ImPointRight /> Critical thinking the problems people daily face and Try to find some Technical solution(Like any idea for software) for that problem.
            </li>
          </ul>

          <p style={{ marginBlockEnd: 0}} className="blue">
            "Always learning makes us better everyday!"{" "}
          </p>
          <footer className="blockquote-footer">Marmik Patel</footer>
        </blockquote>
      </Card.Body>
    </Card>
  );
}

export default AboutCard;
